<!-- Modal Step 1 -->
<ng-container *ngIf="modalType == _sharedService.modalTypes.verifyDebt">
    <div class="modal-dialog document m-0 modal-animate">
        <div style="padding: 40px;padding-bottom: 20px;">
            <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon ursor:pointer;"
                >
                <!-- <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle"> -->
            </div>
            <div class="text-center d-flex justify-content-center mb-3">
                <div class="d-flex align-items-center justify-content-center gap-2"
                    style="background-color: #edfdf3;width: fit-content;padding: 4px 8px; border-radius: 64px;">
                    <img src="assets/images/img/tick.png" style="width: 20px;height: 20px;">
                    <p class="mb-0" style="color:#279f63;font-size: 14px;">Verify Debt & Customer Communication</p>
                </div>

            </div>
            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <h1 style="font-size: 24px; font-weight: 500;">A quick check to protect your business</h1>
                <p style="font-size: 16px;line-height: 1.5;font-weight: 400;margin-bottom: 20px;">Help us verify that
                    your
                    customer agreed to the service & charges and how you usually communicate with them.</p>
                <div
                    style="padding: 16px 24px;background-color: #fffaf1; border-radius: 16px;border: 1px solid #ffe7cf;">
                    <img src="assets/images/img/protectBussiness.png"
                        style="margin-bottom: 16px; height: 74px;width: 74px;">
                    <h3 style="font-size: 18px;line-height: 1.5;">Why This Matters For You</h3>
                    <p style="font-size: 14px;">This verification safeguards your business, ensures compliant communication with customers, and minimizes disputes over debts. Recuvery efforts can only commence once this step is completed.</p>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center p-4" style="background-color: #f2f5f8;">
            <!-- <p class="mb-0" style="color: #42474D;font-size: 16px;cursor: pointer" (click)="onClose()"><span style="text-decoration: underline;">I'll do this
                later</span><br>
                <span style="color: #71757A;font-size: 12px;line-height: 1.5;">Accessible later via Settings.</span>
            </p> -->
            <button
                style="cursor:pointer;background-color: #279f63; padding: 12px 40px;font-size: 18px;color: #ffffff;line-height: 1.5;border: none; border: none;outline: none;border-radius: 8px;"
                (click)="goto()">Get
                Started</button>
        </div>
    </div>
</ng-container>

<!-- Modal Step 2 -->
<ng-container *ngIf="modalType == _sharedService.modalTypes.awaitingApproval">
    <div class="modal-dialog document m-0 ">
        <div style="padding: 40px;padding-bottom: 20px;">
            <div
                class="modal-header p-0 justify-content-between align-items-center border-0 close--icon ursor:pointer;">
                <img (click)='CloseBrandOutreach()' src="assets/images/icons/cross-icon.svg" alt=""
                    class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <img src="assets/images/img//consent-awaiting.png">
                <h1 style="font-size: 24px; font-weight: 500;line-height: 1.4;margin-top: 12px;">Awaiting your approval
                </h1>
                <p style="font-size: 16px;line-height: 1.5;font-weight: 400;margin-bottom: 20px;">We’ve sent a quick
                    approval request to your business email. Please approve it to enable branded recovery outreach.</p>
                <div
                    style="padding: 14px 20px;background-color: #fffaf1; border-radius: 16px;border: 1px solid #ffe7cf;">
                    <div class="steps-container">
                        <h3 class="steps-title">Next Steps:</h3>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">1</div>
                                <div class="step-line"></div>
                            </div>
                            <p>Open the email from Recuvery (check Spam if you don't see it)</p>
                        </div>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">2</div>
                                <div class="step-line"></div>
                            </div>
                            <p>Click <b>"Enable Branded Outreach"</b> button in the email </p>
                        </div>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">3</div>
                            </div>
                            <p>You’re all set—Recuvery can move forward</p>
                        </div>

                    </div>
                </div>
                <!-- <p *ngIf="totalSeconds > 0" style="font-size: 16px;line-height: 1.5;color: #42474d;margin-top: 24px;">Link Expires in
                    <span style="color: #279f63;">{{ displayTime }} min</span></p> -->
                <div>
                    <!-- <p style="font-size: 16px;line-height: 1.5;color: #42474d;margin-top: 24px;">Link Expired!</p> -->
                    <button class="resend-btn mt-3" (click)="resendEmail()">Resend Email</button>
                </div>
                <!-- <p style="font-size: 14px;color: #42474d;line-height: 1.5;">Didn’t receive the email? <a (click)="resendEmail()">Resend approval email</a></p> -->
            </div>
        </div>

    </div>
</ng-container>

<!-- Modal Cosent Successfull -->

<ng-container *ngIf="modalType == _sharedService.modalTypes.consentSucessfull">
    <div class="modal-dialog document m-0 ">
        <div style="padding: 40px;padding-bottom: 20px;">
            <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon cursor:pointer;"
                (click)="goToDashboard()" routerLink="/app/dashboard">
                <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <img src="assets/images/img/protectBussiness.png">
                <h1 style="font-size: 24px; font-weight: 500;line-height: 1.4;margin-top: 12px;">Consent submitted
                    successfully!</h1>
                <p style="font-size: 15px;line-height: 1.5;font-weight: 400;margin-bottom: 20px;">Thanks for submitting
                    the customer’s consent for the debt and communication. We’ll notify you as soon as verification is
                    done.</p>
                <div
                    style="padding: 16px 18px;background-color: #fffaf1; border-radius: 16px;border: 1px solid #ffe7cf;">
                    <p style="font-size: 13px;line-height: 1.5;font-weight: 400;margin-bottom: 0;">Branded outreach is
                        currently turned off. Using your domain helps emails get opened and trusted faster. <a
                            href="#">Enable Branded Outreach</a></p>
                </div>
                <button
                    style="background-color: #279f63;color: #ffffff;padding: 12px 40px;border: none;outline: none;border-radius: 8px;font-size: 18px;margin-top: 24px;"
                    (click)="goToDashboard()">Continue for Now</button>

            </div>
        </div>

    </div>
</ng-container>


<!-- Check Your Email  -->

<ng-container *ngIf="modalType == _sharedService.modalTypes.checkEmail">
    <div class="modal-dialog document m-0 ">
        <div style="padding: 40px;padding-bottom: 20px;">
            <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon ursor:pointer;"
                (click)="CloseBrandOutreach()">
                <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <img src="assets/images/img//consent-awaiting.png">
                <h1 style="font-size: 24px; font-weight: 500;line-height: 1.4;margin-top: 12px;">Check Your Email</h1>
                <p style="font-size: 16px;line-height: 1.5;font-weight: 400;margin-bottom: 20px;">We've sent an
                    authorization email to your business email address</p>
                <div
                    style="padding: 14px 20px;background-color: #fffaf1; border-radius: 16px;border: 1px solid #ffe7cf;">
                    <div class="steps-container">
                        <h3 class="steps-title">Next Steps:</h3>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">1</div>
                                <div class="step-line"></div>
                            </div>
                            <p>Open the email from Recuvery (check Spam if you don't see it)</p>
                        </div>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">2</div>
                                <div class="step-line"></div>
                            </div>
                            <p>Click <b>"Enable Branded Outreach"</b> button in the email </p>
                        </div>

                        <div class="step">
                            <div class="step-left">
                                <div class="step-number">3</div>
                            </div>
                            <p>You’re all set—Recuvery can move forward</p>
                        </div>

                    </div>
                </div>
                <!-- <p style="font-size: 16px;line-height: 1.5;color: #42474d;margin-top: 24px;">Link Expires in <span
                        style="color: #279f63;">{{ displayTime }} min</span></p> -->
                <!-- <p style="font-size: 14px;color: #42474d;line-height: 1.5;">Didn’t receive the email? <a >Resend approval email</a></p> -->
            </div>
        </div>

    </div>
</ng-container>


<ng-container *ngIf="modalType == _sharedService.modalTypes.allSet">
    <div class="modal-dialog document m-0 ">
        <div style="padding: 40px;padding-bottom: 20px;">
            <div
                class="modal-header p-0 justify-content-between align-items-center border-0 close--icon cursor:pointer;">
                <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <img src="../../../../assets/images/icons/greenTick.svg">
                <h1 style="font-size: 24px; font-weight: 500;line-height: 1.4;margin-top: 12px;">You're All Set! 🎉</h1>
                <p style="font-size: 16px;line-height: 1.5;font-weight: 400;margin-bottom: 20px;">Your branded email
                    outreach is now enabled. We'll start reaching out to your customers to maximize response rates and
                    accelerate debt recovery.</p>


            </div>
        </div>

    </div>
</ng-container>
<ng-container *ngIf="modalType == _sharedService.modalTypes.pendingApproval">
    <div
        style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">

        <div
            style="background: #fff; padding: 40px; max-width: 580px;border-radius: 16px; text-align: center;" class="modal-animate">

            <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon cursor:pointer;"
                (click)='CloseBrandOutreach()'>
                <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <img src="assets/images/img/consent-awaiting.png" style="width: 100px; margin: 0 auto 20px; display: block;"
                alt="Outreach Icon">

            <h1 style="font-size: 24px; font-weight: 600; color: #0D1321; margin-bottom: 8px; line-height: 1.5;">
                Recover Funds Faster with Branded Outreach
            </h1>

            <p style="font-size: 16px; line-height: 1.5; color: #2b3038; margin-bottom: 24px;">
                Enable branded outreach so recovery messages are
                <strong style="color: #2b3038;">recognized, trusted, and acted on faster.</strong>
            </p>

            <div
                style="background: #fffaf1; border: 1px solid #ffe7cf; border-radius: 16px; padding: 24px; margin-bottom: 30px;">
                <h3 style="font-size: 16px; font-weight: 600; color: #0D1321; margin-bottom: 20px;">
                    Let us reach customers on your behalf—securely
                </h3>

                <div style="display: flex; justify-content: center; gap: 15px; flex-wrap: wrap;">
                    <div
                        style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #42474D; font-weight: 500;">
                        <div
                            style="width: 20px; height: 20px; background: #279f63; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4"
                                stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        One-click approval
                    </div>

                    <div
                        style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #4a5568; font-weight: 500;">
                        <div
                            style="width: 20px; height: 20px; background: #279f63; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4"
                                stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        Fully compliant
                    </div>

                    <div
                        style="display: flex; align-items: center; gap: 8px; font-size: 14px; color: #4a5568; font-weight: 500;">
                        <div
                            style="width: 20px; height: 20px; background: #279f63; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4"
                                stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        Revoke anytime
                    </div>
                </div>
            </div>

            <button
                style="width: 100%; background: #279f63; border: none; color: #fff; padding: 16px; border-radius: 12px; font-size: 18px; font-weight: 600; cursor: pointer; transition: background 0.2s;"
                (click)="enableOutreach()">
                Enable High-Recovery Outreach
            </button>

            <p style="margin-top: 20px; font-size: 14px; color: #718096;">
                You’re always in control. Update or revoke anytime from <strong
                    style="color: #4a5568;">Settings</strong>
            </p>

        </div>
    </div>
</ng-container>

<ng-container *ngIf="modalType == _sharedService.modalTypes.outreachRequired">
    <div class="modal-dialog document m-0">
        <div style="padding: 25px;padding-bottom: 20px; width : 100%;">
            <div class="modal-header p-0 justify-content-between align-items-center border-0 close--icon cursor:pointer;"
                (click)="goToDashboard()">
                <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border p-1 cursor rounded-circle">
            </div>

            <div class="fs-16 fw-500 modal-body p-0 mt-1 mb-2 text-center mt-2">
                <img src="assets/images/img/consent-awaiting.png"
                    style="width: 100px; margin: 0 auto 20px; display: block;" alt="Outreach Icon">
                <h1 style="font-size: 24px; font-weight: 500;line-height: 1.4;margin-top: 12px;margin-bottom: 6px;">
                    Branded Outreach
                    Required!</h1>
                <p style="font-size: 16px;line-height: 1.5;font-weight: 400;margin-bottom: 20px; color: #2B3038;">Since
                    <b>E-Consent
                        Verification &
                        Communication is set to “No”,</b> branded outreach needs to be enabled to continue.
                    <br><br>Using your
                    own domain helps improve email trust and delivery.</p>
                <button
                    style="background-color: #279f63;color: #ffffff;padding: 12px 40px;border: none;outline: none;border-radius: 8px;font-size: 18px;margin-top: 18px;" (click)="cancelOutreach()">Resume
                    Branded Outreach</button><br>
                <button
                    style="color: #42474D;padding: 12px 40px;border: none;outline: none;border-radius: 8px;font-size: 18px;margin-top: 14px; background: transparent;" (click)="goToDashboard()">Cancel</button>

            </div>
        </div>

    </div>
</ng-container>

<ng-container *ngIf="modalType == _sharedService.modalTypes.revokeOutreach">
    <!-- Modal Card -->
    <div style="
        background: white;
        width: 100%;
        box-sizing: border-box;
        border-radius: 28px;
        padding: 40px;
        position: relative;
        box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    " class="modal-animate">

            <!-- Close Button -->
            <div (click)="cancelOutreach()" style="
            position: absolute;
            top: 20px;
            right: 20px;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            border: 2px solid #cfd6df;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background: white;
      ">
                <img src="assets/images/icons/cross-icon.svg" style="width:18px;">
            </div>

            <!-- Title -->
            <h1 style="
          font-size: 30px;
          font-weight: 600;
          line-height: 1.3;
          color: #1c2331;
          margin-bottom: 40px;
          padding-right: 40px;
      ">
                Are you sure you want to <br>
                revoke branded outreach?
            </h1>

            <!-- Buttons Row -->
            <div style="
          display: flex;
          gap: 20px;
          justify-content: flex-start;
      ">

                <!-- Cancel -->
                <button (click)="cancelOutreach()" style="
            flex: 1;
            height: 56px;
            font-size: 18px;
            font-weight: 500;
            border-radius: 10px;
            border: 2px solid #A2A8B0;
            background: transparent;
            color: #1c2331;
            cursor: pointer;
        ">
                    Cancel
                </button>

                <!-- Revoke -->
                <button (click)="revokeOutreach()" style="
            flex: 1;
            height: 56px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 10px;
            border: none;
            background: #EB3838;
            color: white;
            cursor: pointer;
        ">
                    Revoke
                </button>

            </div>

        </div>
</ng-container>